import { Injectable } from "@angular/core";
import { APP_SETTINGS } from "../../shared/models/backofficeConfiguration";
import { ExecuteService } from "../../shared/services/executeService.service";
import { ErrorHandlerService } from "../../shared/services/errorHandler.service";
import { Observable } from "rxjs/Observable";
import { BrokerItem } from "../model/BrokerItem";
import { map, catchError } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import { Broker } from "../model/Broker";
import { BrokerApiFilter } from "../model/BrokerFilter";
import { AlertService } from "../../shared/alert/services/alert.service";
import { isNullOrEmpty } from "../components/scripts/broker-model-utils";

@Injectable()
export class BrokerService {
    private brokersApiURL = APP_SETTINGS.BrokersApiUrl;
    constructor(
        private executeService: ExecuteService,
        private errorHandler: ErrorHandlerService,
        private alertService: AlertService
    ) { }

    public GetBrokers(locale: string, filter: BrokerApiFilter): Observable<BrokerItem[]> {
        const url = `${this.brokersApiURL}${locale}/api/v1/broker/all`;
        let params = new HttpParams();
        if (filter.Name != '') {
            params = params.set('name', filter.Name);
        }
        if (filter.Country != '') {
            params = params.set('country', filter.Country);
        }
        if (filter.IsActive) {
            params = params.set('isActive', `${filter.IsActive}`);
        }

        return this.executeService.ExecuteWithToken('get', url, params)
            .pipe(
                map(response => this.mapBrokerItemResponses(response)),
                catchError(this.errorHandler.handleError<object[]>('BrokerService_GetBrokers', [], true))
            );
    }

    public GetBrokerById(locale: string, id: string): Observable<Broker> {
        const url = `${this.brokersApiURL}${locale}/api/v1/broker/${id}`;

        return this.executeService.ExecuteWithToken('get', url)
            .pipe(
                catchError(this.errorHandler.handleError<object>('BrokerService_GetBrokerById', null))
            );
    }

    public CreateBroker(locale: string, broker: Broker): Observable<Broker> {
        var url = `${this.brokersApiURL}${locale}/api/v1/broker`;
        var data = broker;
        return this.executeService.ExecuteWithToken('post', url, null, data)
            .pipe(
                catchError(this.errorHandler.handleError<object>('BrokerService_CreateBroker', null))
            );
    }

    public EditBroker(locale: string, broker: Broker): Observable<any> {
        var url = `${this.brokersApiURL}${locale}/api/v1/broker/${broker.id}`;
        var data = broker;
        return this.executeService.ExecuteWithToken('put', url, null, data)
            .pipe(
                catchError(this.errorHandler.handleError<object>('BrokerService_EditBroker', null))
            );
    }

    public DeleteBroker(locale: string, id: string): Observable<any> {
        var url = `${this.brokersApiURL}${locale}/api/v1/broker/${id}`;
        return this.executeService.ExecuteWithToken('delete', url)
            .pipe(
                catchError(this.errorHandler.handleError<object>('BrokerService_DeleteBroker', null))
            );
    }

    public ValidateBroker(broker: Broker): Boolean {

        const brokerFirstLevelUrls = [
            broker.freeDemoUrl ? broker.freeDemoUrl : "",
            broker.liveAccountUrl ? broker.liveAccountUrl : "",
            broker.termsAndConditionsUrl ? broker.termsAndConditionsUrl : "",
            broker.pairsUrl ? broker.pairsUrl : "",
            broker.termsAndConditionsUrl ? broker.termsAndConditionsUrl : "",
            broker.contactInformation.customerServiceUrl ? broker.contactInformation.customerServiceUrl : "",
            broker.contactInformation.websiteUrl ? broker.contactInformation.websiteUrl : "",
            broker.contactInformation.faqUrl ? broker.contactInformation.faqUrl : "",
            broker.pammPolicyUrl ? broker.pammPolicyUrl : ""
        ];

        const brokerEducationProgramUrls = broker.educationPrograms.map(educationProgram => educationProgram.url ? educationProgram.url : "");

        const brokerPromotionsUrls = broker.promotions.map(promotion => promotion.url ? promotion.url : "")

        if (!broker.imageUrl.startsWith("https://editorial.fxsstatic.com/")) {
          this.alertService.add('danger', 'ALERT. The image URL must be hosted on: https://editorial.fxsstatic.com/');
            return false;
        }

        if (broker.name.length > 30) {
            this.alertService.add('danger', 'ALERT. Broker name cannot be larger than 30 characters (Including spaces).');
            return false;
        }
        return true;
    }

    private mapBrokerItemResponses(brokers: any[]): any {
        let response: BrokerItem[] = [];
        if (brokers != null) {
            response = brokers.map(b => ({
                id: b.id,
                name: b.name,
              isActive: b.isActive,
              products: {
                listing: b.inListing,
                reviews: !isNullOrEmpty(b.reviewUrl),
                showcases: !isNullOrEmpty(b.showcaseOpenAccountUrl),
              }
            }));
        }
        return response;
    }
}



// WEBPACK FOOTER //
// ./src/app/brokers/services/broker.service.ts